import { COLORS } from "./constants";
import type { ChartLayout } from "./types";

export function drawExpiryLine(
  ctx: CanvasRenderingContext2D,
  expiryTime: number,
  layout: ChartLayout,
  timeToX: (timestamp: number) => number,
  hideSeconds = false,
) {
  const { left, right, top, bottom, width: w, height: h } = layout;
  const expiryX = timeToX(expiryTime);

  if (expiryX >= left && expiryX <= w - right) {
    ctx.save();
    ctx.strokeStyle = COLORS.line;
    ctx.lineWidth = 0.8;
    ctx.setLineDash([]);
    ctx.beginPath();
    ctx.moveTo(expiryX, top);
    ctx.lineTo(expiryX, h - bottom);
    ctx.stroke();
    ctx.restore();
  }

  const lineX = expiryX - 1;
  const flagWidth = 20;
  const flagHeight = 10;

  ctx.fillStyle = COLORS.line;
  ctx.beginPath();
  ctx.moveTo(lineX, top);
  ctx.lineTo(lineX + flagWidth, top);
  ctx.lineTo(lineX + flagWidth - flagWidth / 5, top + flagHeight / 2);
  ctx.lineTo(lineX + flagWidth, top + flagHeight);
  ctx.lineTo(lineX, top + flagHeight);
  ctx.closePath();
  ctx.fill();

  const date = new Date(expiryTime);
  const hh = date.getHours().toString().padStart(2, "0");
  const mm = date.getMinutes().toString().padStart(2, "0");
  const ss = date.getSeconds().toString().padStart(2, "0");
  const label = hideSeconds ? `${hh}:${mm}` : `${hh}:${mm}:${ss}`;

  ctx.fillStyle = COLORS.label;
  const textWidth = ctx.measureText(label).width;
  const titleWidth = ctx.measureText("Expiration time").width;
  ctx.fillText("Expiration time", expiryX + titleWidth / 2 + 6, top + 20);
  ctx.fillText(label, expiryX + textWidth / 2 + 6, top + 33);
}
